import { Component } from 'react'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo)
    this.setState({
      error,
      errorInfo
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '40px',
          maxWidth: '600px',
          margin: '80px auto',
          textAlign: 'center',
          fontFamily: 'Space Grotesk, sans-serif'
        }}>
          <h1 style={{ fontSize: '2.5rem', marginBottom: '16px', color: '#111017' }}>
            Something went wrong
          </h1>
          <p style={{ fontSize: '1.1rem', color: 'rgba(17, 16, 23, 0.65)', marginBottom: '24px' }}>
            We apologize for the inconvenience. Please refresh the page or contact support if the problem persists.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 24px',
              backgroundColor: '#111017',
              color: '#faf7f1',
              border: 'none',
              borderRadius: '999px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Refresh Page
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details style={{ marginTop: '32px', textAlign: 'left' }}>
              <summary style={{ cursor: 'pointer', fontWeight: '600', marginBottom: '8px' }}>
                Error Details (Development Only)
              </summary>
              <pre style={{
                padding: '16px',
                backgroundColor: '#f4efe6',
                borderRadius: '8px',
                overflow: 'auto',
                fontSize: '0.9rem'
              }}>
                {this.state.error.toString()}
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
